export const LIVE_CHAT_PLACEHOLDER_ID = 'livechat-placeholder';

export const LIVECHAT_MINIMIZED_ID = 'chat-widget-minimized';
export const LIVECHAT_CONTAINER_ID = 'chat-widget-container';

export const LIVECHAT_WIDGET_NODE_IDS = [
  LIVECHAT_MINIMIZED_ID,
  LIVECHAT_CONTAINER_ID,
] as const;
